import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CreationProjetService {
  protected apiRoute = environment.RESOURCE_API;

  constructor(private _httpClient: HttpClient) { }

  depotProjectFinancement(
    companyId: string,
    partnerId: string,
    projectFinancementFilesBody: any,
    mandateId?: string | null,
    partnerName?: string | null,
    mandateName?: string | null
  ): Observable<any> {
  
    const baseUrl =
      this.apiRoute +
      environment.apiCatalog.projectFinancement.controllerRoute +
      environment.apiCatalog.projectFinancement.subRoutes.depotProjectFinancement;

    // Construction dynamique des query params
    let params = new HttpParams()
      .set('companyId', companyId)
      .set('partnerId', partnerId)
      .set('partnerName', partnerName || '');

    if (mandateId) {
      params = params.set('mandateId', mandateId);
      params = params.set('mandateName', mandateName || '');
    }

    return this._httpClient.post<any>(baseUrl, projectFinancementFilesBody, {
      params,
      headers: new HttpHeaders({
      }),
    });
  }

    depotProjectFinancementDova(
    projectId: string,
    projectFinancementFilesBody: any,
  ): Observable<any> {
    const baseUrl =
      this.apiRoute +
      environment.apiCatalog.projectFinancement.controllerRoute +
      environment.apiCatalog.projectFinancement.subRoutes.depotProjectFinancementDova + projectId;

    return this._httpClient.put<any>(baseUrl, projectFinancementFilesBody, {
      headers: new HttpHeaders({
      }),
    });
  }


  checkIfProjectExists(projectId: string): Observable<boolean> {
    const route = this.apiRoute + environment.apiCatalog.projectFinancement.controllerRoute + environment.apiCatalog.projectFinancement.subRoutes.checkIfProjectExists + projectId;
    return this._httpClient.get<boolean>(route, {
      headers: {
        // Do NOT set 'Content-Type'; let the browser set it with boundary
      }
    });
  }
}
